import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ReviewFlowDataResult, ReviewFlowResourceType } from "@ServerTypes/reviewflows/reviewflows.schema";
import type { ReviewDataResult } from "@ServerTypes/reviews/reviews.schema";

const reviewFlowDataSlice = createSlice({
  name: "reviewFlowData",
  initialState: {} as Partial<ReviewFlowDataResult>,
  reducers: {
    setReviewFlowData: (_state: Partial<ReviewFlowDataResult>, action: PayloadAction<Partial<ReviewFlowDataResult>>) =>
      action.payload,
  },
});

// The lazy initialiser is what makes `State` the whole enum: a literal seed widens it to `string`, and a
// union-annotated const narrows to its initialiser at this call, inferring `"RESOURCE_TYPE_FILE"` alone.
const reviewFlowResourceTypeSlice = createSlice({
  name: "reviewFlowResourceType",
  initialState: (): ReviewFlowResourceType => "RESOURCE_TYPE_FILE",
  reducers: {
    setReviewFlowResourceType: (_state: ReviewFlowResourceType, action: PayloadAction<ReviewFlowResourceType>) =>
      action.payload,
  },
});

const reviewDataSlice = createSlice({
  name: "reviewData",
  initialState: {} as ReviewDataResult,
  reducers: {
    setReviewData: (_state: ReviewDataResult, action: PayloadAction<ReviewDataResult>) => action.payload,
  },
});

export const { setReviewFlowData } = reviewFlowDataSlice.actions;
export const { setReviewFlowResourceType } = reviewFlowResourceTypeSlice.actions;
export const { setReviewData } = reviewDataSlice.actions;

export const reviewFlowData = reviewFlowDataSlice.reducer;
export const reviewFlowResourceType = reviewFlowResourceTypeSlice.reducer;
export const reviewData = reviewDataSlice.reducer;

export default reviewFlowDataSlice.reducer;
